import React from "react";
import "./Home.css";
export function Home(){
    return(
            <div class="justify-content-center container">
          <div class="webinar-box">
            <div className="unlock-title">Unlock the Secrets of Vastu Aroma Healing</div>
            <h1 className="main-title">VASTU AND AROMA</h1>
            <p className="sub-1-title">Offline Session!</p>
            <p className="sub-2-title">
              📢 2-Day Exclusive Offline Workshop with Guruji Arihant Raaj
            </p>
            <p className="sub-3-title">
            Are you ready to transform your space and energy using the power of Vastu Shastra and Aroma Therapy?<br/>
            Join us for an immersive 2-day offline class guided by the renowned <strong>Arihant Raaj</strong>, where ancient wisdom meets modern healing.
            </p>
          </div>
        </div> 
    )
}